const IconOtherHouses = () => {
    return (
        <svg
            width="47"
            height="47"
            viewBox="0 0 47 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M23.5002 5.875L1.9585 22.325L4.32808 25.4387L7.8335 22.7558V41.125H39.1668V22.7558L42.6723 25.4192L45.0418 22.325L23.5002 5.875ZM35.2502 37.2083H11.7502V19.7792L23.5002 10.81L35.2502 19.7792V37.2083ZM17.6252 27.4167C17.6252 28.4937 16.7439 29.375 15.6668 29.375C14.5897 29.375 13.7085 28.4937 13.7085 27.4167C13.7085 26.3396 14.5897 25.4583 15.6668 25.4583C16.7439 25.4583 17.6252 26.3396 17.6252 27.4167ZM23.5002 25.4583C24.5772 25.4583 25.4585 26.3396 25.4585 27.4167C25.4585 28.4937 24.5772 29.375 23.5002 29.375C22.4231 29.375 21.5418 28.4937 21.5418 27.4167C21.5418 26.3396 22.4231 25.4583 23.5002 25.4583ZM29.3752 27.4167C29.3752 26.3396 30.2564 25.4583 31.3335 25.4583C32.4106 25.4583 33.2918 26.3396 33.2918 27.4167C33.2918 28.4937 32.4106 29.375 31.3335 29.375C30.2564 29.375 29.3752 28.4937 29.3752 27.4167Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconOtherHouses;
